<template>
  <div class="flex justify-center mt-3">
    <button
      type="button"
      @click="signInWithMicrosoft"
      :disabled="isLoading"
      class="flex items-center justify-center gap-2 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 transition-colors"
      style="width: 300px; height: 40px; font-size: 14px; font-family: 'Segoe UI', sans-serif;"
      :class="isLoading ? 'opacity-50 cursor-not-allowed' : ''"
    >
      <span class="flex items-center justify-center" style="width: 22px; height: 22px; flex-shrink: 0;">
        <img src="@/assets/cs-logo.png" style="width: 20px; height: 20px; object-fit: contain; mix-blend-mode: screen; opacity: 0.95;" />
      </span>
      <span>{{ isLoading ? 'Signing in...' : 'Sign in with Cloudstaff email' }}</span>
    </button>
  </div>
</template>

<script>
import { PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      isLoading: false,
      loadingMessage: 'Verifying account',
      msalInstance: null,
    };
  },

  async mounted() {
    try {
      await this.initMsal();
    } catch {
      // crypto not available in this environment (e.g. test runner)
    }
  },

  methods: {
    async initMsal() {
      const instance = new PublicClientApplication({
        auth: {
          clientId: this.azure_client_id,
          authority: `https://login.microsoftonline.com/${this.azure_tenant_id}`,
          redirectUri: window.location.origin,
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
      });
      await instance.initialize();
      this.msalInstance = instance;
    },

    async signInWithMicrosoft() {
      if (!this.msalInstance) {
        this.$moshaToast('Microsoft Sign-In is not available. Please try again.', { type: 'danger' });
        return;
      }

      this.isLoading = true;

      try {
        const loginResponse = await this.msalInstance.loginPopup({
          scopes: ['User.Read'],
          prompt: 'select_account',
        });

        Swal.fire({
          title: 'Please wait...',
          html: '<small>Verifying Microsoft account</small>',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const res = await axios({
          method: 'post',
          url: this.baseAPIURL + '/apiv3/microsoft365Callback',
          data: {
            token: loginResponse.accessToken,
            device_identifier: 'TAPWEBIDENTIFIER',
            device_type: 'WEB',
            device_info: 'BROWSER',
            location: '',
            ip_public: '',
          },
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (res.data.data.result === 'success') {
          this.loadingMessage = 'Loading theme';
          Swal.update({ html: `<small>${this.loadingMessage}</small>` });

          const themeData = new FormData();
          themeData.append('email', res.data.data.email);

          const themeResponse = await axios({
            method: 'post',
            url: this.baseAPIURL + '/apiv3/theme.json',
            data: themeData,
            headers: {
              auth: res.data.data.token,
              'Content-Type': 'multipart/form-data',
            },
          });

          this.$store.dispatch('verify', {
            email: res.data.data.email,
            token: res.data.data.token,
            user_guid: res.data.data.guid,
          });

          this.$store.dispatch('updateNewLoad', true);
          Swal.close();
          this.$store.dispatch('updateTheme', themeResponse.data.theme[0].web_main_page_icon);

          res.data.data.data.book_code.map((item, index) => {
            if (index === 0) {
              if (this.$store.getters.selected_book === '') {
                this.$store.dispatch('activeBook', item.code);
                this.$store.dispatch('activeBookDesc', item.description);
                this.$store.dispatch('setPages', item.pages);
              }
              this.$store.dispatch('setBooks', item.code);
              this.$store.dispatch('setActiveBooks', item.code);
              this.$store.dispatch('setSelectedBookModDate', item.modified);
            } else {
              this.$store.dispatch('setBooks', item.code);
              this.$store.dispatch('setActiveBooks', item.code);
              this.$store.dispatch('setSelectedBookModDate', item.modified);
            }

            if (/@cloudstaff\.com\s*$/.test(res.data.data.email)) {
              this.$store.dispatch('setCS', true);
            } else {
              this.$store.dispatch('setCS', false);
            }
          });

          this.$moshaToast('Welcome!', { type: 'success' });
          this.$router.push('/dashboard');
        } else {
          Swal.close();
          this.$moshaToast('Microsoft sign-in failed. Please try again.', { type: 'danger' });
        }
      } catch (error) {
        Swal.close();
        if (error && error.errorCode === 'user_cancelled') {
          this.isLoading = false;
          return;
        }
        this.$moshaToast('Microsoft sign-in failed. Please try again.', { type: 'danger' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
